import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=0707309f&scoped=true&"
import script from "./VideoItem.vue?vue&type=script&lang=ts&"
export * from "./VideoItem.vue?vue&type=script&lang=ts&"
import style0 from "./VideoItem.vue?vue&type=style&index=0&id=0707309f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707309f",
  null
  
)

export default component.exports